// Check if the body class contains 'nodeWinkel'
if (document.body.classList.contains('nodeWinkel')) {
  // Zoek de tabel met de klasse 'tablefield'
  const table = document.querySelector('.winkelHours .tablefield');

  // Zoek alle rijen in de tabel
  const rows = table.querySelectorAll('tr');

  // Loop door elke rij, beginnend vanaf de tweede rij (index 1)
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i];
    const cells = row.querySelectorAll('td');

    // Controleer of de tweede en derde cel 'Gesloten' bevatten
    if (
      cells.length >= 3
      && cells[1].textContent.includes('Gesloten')
      && cells[2].textContent.includes('Gesloten')
    ) {
      // Verberg de rij met CSS
      row.style.display = 'none';
    }
  }

  // Loop nogmaals door de rijen om de verborgen rijen uit de DOM te verwijderen
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i];

    // Controleer of de rij verborgen is
    if (row.style.display === 'none') {
      // Verwijder de verborgen rij uit de DOM
      row.remove();
    }
  }
}
